import { Injectable } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { BaseApiService } from '../../services/api/base-api.service';
import {
  AddApplicationRequestModel,
  AddApplicationResponseModel,
  AddGuarantorToApplicationRequestModel,
  AddGuarantorToApplicationResponseModel,
  RemoveGuarantorFromApplicationResponse,
  AddAssetFileToApplicationRequestModel,
  AddAssetFileToApplicationResponseModel,
  RemoveAssetFileFromApplication,
  RemoveAssetFileFromApplicationRequestModel,
  UpdateApplicationRequestModel,
  UpdateApplicationResponseModel,
  AddSecuritiesRequestModel,
  AddSecuritiesResponseModel,
  SubmitApplicationForProcessingRequestModel,
  SubmitApplicationForProcessingResponseModel,
  GetApplicationResponseModel,
} from '../../models/applications.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {
  APPLICATIONS,
  ASSETS,
  SECURITIES,
  SUBMIT_APPLICATION,
  UPDATE_APPLICATION,
} from '../../app.consts';
import { TrackingService } from 'src/app/services/tracking.service';

@Injectable()
export class ApplicationsApiService extends BaseApiService {
  constructor(
    protected auth: AuthService,
    private http: HttpClient,
    private trackingService: TrackingService
  ) {
    super(auth);
  }

  addApplication(
    body: AddApplicationRequestModel
  ): Observable<AddApplicationResponseModel> {
    this.trackingService.createdApplication(body.amount);
    return this.http.post<AddApplicationResponseModel>(
      `${this.apiUrl}${APPLICATIONS}`,
      body,
      this.authHeader
    );
  }

  updateApplication(
    body: UpdateApplicationRequestModel
  ): Observable<UpdateApplicationResponseModel> {
    return this.http.put<UpdateApplicationResponseModel>(
      `${this.apiUrl}${UPDATE_APPLICATION}/${body.applicationId}`,
      body,
      this.authHeader
    );
  }

  addGuarantorToApplication(
    applicationId: number,
    contactId: number,
    body: AddGuarantorToApplicationRequestModel
  ): Observable<AddGuarantorToApplicationResponseModel> {
    return this.http.post<AddGuarantorToApplicationResponseModel>(
      `${this.apiUrl}${UPDATE_APPLICATION}/${applicationId}/collateral/${contactId}`,
      body,
      this.authHeader
    );
  }

  removeGuarantorFromApplication(
    applicationId: number,
    contactId: number
  ): Observable<RemoveGuarantorFromApplicationResponse> {
    return this.http.delete(
      `${this.apiUrl}${UPDATE_APPLICATION}/${applicationId}/collateral/${contactId}`,
      this.authHeader
    );
  }

  addAssetFileToApplication(
    body: AddAssetFileToApplicationRequestModel
  ): Observable<AddAssetFileToApplicationResponseModel> {
    const data: FormData = new FormData();
    data.append('data', body.data);
    data.append('name', body.name);
    return this.http.post<AddAssetFileToApplicationResponseModel>(
      `${this.apiUrl}${UPDATE_APPLICATION}/${body.applicationId}${ASSETS}`,
      data,
      this.authHeader
    );
  }

  removeAssetFileFromApplication(
    body: RemoveAssetFileFromApplicationRequestModel
  ): Observable<RemoveAssetFileFromApplication> {
    return this.http.delete<RemoveAssetFileFromApplication>(
      `${this.apiUrl}${UPDATE_APPLICATION}/${body.applicationId}${ASSETS}/${body.name}/${body.fileName}`,
      this.authHeader
    );
  }

  addSecurity(
    body: AddSecuritiesRequestModel
  ): Observable<AddSecuritiesResponseModel> {
    return this.http.post<AddSecuritiesRequestModel>(
      `${this.apiUrl}${UPDATE_APPLICATION}/${body.applicationId}${SECURITIES}`,
      body,
      this.authHeader
    );
  }

  submitApplicationForProcessing(
    body: SubmitApplicationForProcessingRequestModel
  ): Observable<SubmitApplicationForProcessingResponseModel> {
    this.trackingService.submitApplication();
    return this.http.post<SubmitApplicationForProcessingRequestModel>(
      `${this.apiUrl}${SUBMIT_APPLICATION}/${body.applicationId}/process`,
      {},
      this.authHeader
    );
  }

  getApplication(
    applicationId: string | number
  ): Observable<GetApplicationResponseModel> {
    return this.http.get<GetApplicationResponseModel>(
      `${this.apiUrl}${APPLICATIONS}/${applicationId}`,
      this.authHeader
    );
  }
}
